<mat-sidenav-container class="container-nav">
  <mat-sidenav
    id="nav"
    class="nav nav-fechada"
    mode="side"
    opened
    fixedInViewport="true"
    [disableClose]="true">

    <mat-nav-list class="nav-list" id="nav-list">
      <div class="menus-superior-sidebar">
        <div id="logo-menu" class="logo-menu text-light p-2">
          <span>
            <img
              [src]="open ? 'assets/logo-premoplan-completa.svg' : 'assets/logo-premoplan.svg'"
              [class]="'logo-premoplan'">
          </span>
        </div>

        <div class="itens-menu" *ngFor="let item of conteudoSideNav">
          <div *ngIf="item.permissao && !item.submenu">
            <a
              id="{{ item.nome + 'IconId' }}"
              class="opcao-clique icon"
              mat-list-item
              [routerLink]="[item.link]"
              routerLinkActive="active-link"
              #tooltip="matTooltip"
              [matTooltip]="item.nome | transloco"
              matTooltipPosition="after"
              [matTooltipDisabled]="open"
              matTooltipClass="tooltip-menu"
              (mouseenter)="tooltip.show()">
              <img class="icone-menu" [src]="item.icone">
              <span *ngIf="open">
                <p class="nome-menu v-middle mb-0 ml-2 text-light">
                  {{ item.nome | transloco }}
                </p>
              </span>
            </a>
          </div>

          <div *ngIf="item.submenu && item.submenu.length > 0" class="submenu-container">
            <a
              [class.item-ativo]="item.open"
              mat-list-item
              class="icon"
              (click)="item.open = !item.open; item.acao!()"
              [matTooltip]="item.nome | transloco"
              matTooltipPosition="after"
              [matTooltipDisabled]="open"
              matTooltipClass="tooltip-menu">
              <img class="icone-menu" [src]="item.icone">
              <span *ngIf="open">
                <p class="nome-menu v-middle mb-0 ml-2 text-light">
                  {{ item.nome | transloco }}
                </p>
              </span>
              <img
                *ngIf="open"
                [src]="item.open
                  ? 'assets/icones-sideBar/icone-fechar-expansao.svg'
                  : 'assets/icones-sideBar/icone-expandir.svg'"
                [id]="item.open ? 'botao-abrir-submenu' : 'botao-fechar-submenu'">
            </a>

            <div *ngIf="item.open && open" class="submenu-wrapper">
              <div class="submenu">
                <a
                  id="{{ sub.nome + 'IconId' }}"
                  class="opcao-submenu icon"
                  mat-list-item
                  [routerLink]="[sub.link]"
                  *ngFor="let sub of item.submenu"
                  routerLinkActive="active-link"
                  #tooltip="matTooltip"
                  matTooltip="{{ sub.nome | transloco }}"
                  matTooltipPosition="after"
                  [matTooltipDisabled]="open"
                  matTooltipClass="tooltip-menu"
                  (mouseenter)="tooltip.show()">
                  <span *ngIf="open">
                    <p class="nome-menu v-middle mb-0 ml-2 text-light">
                      {{ sub.nome | transloco }}
                    </p>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="menus-inferiores-sidebar">
        <hr>
        <div class="itens-menu">
          <a
            id="itemTraduzirPremoplan"
            mat-list-item
            class="icon"
            (click)="abrirModal()"
            [matTooltip]="'COMPONENTS.SIDEBAR.language' | transloco"
            matTooltipPosition="after"
            [matTooltipDisabled]="open"
            matTooltipClass="tooltip-menu">
            <img
              id="icone_traduzir_premoplan"
              class="icone-menu traduzir"
              src="assets/mapa/filtros/translate.svg">
            <span *ngIf="open">
              <p class="nome-menu v-middle mb-0 ml-2 text-light">
                {{ 'COMPONENTS.SIDEBAR.translate_page' | transloco }}
              </p>
            </span>
          </a>

          <a
            id="itemPremocenter"
            mat-list-item
            class="icon"
            (click)="retornarPremocenter()"
            matTooltip="{{ 'COMPONENTS.SIDEBAR.go_premocenter' | transloco }}"
            matTooltipPosition="after"
            [matTooltipDisabled]="open"
            matTooltipClass="tooltip-menu">
            <img
              id="icone_sair_premoplan"
              class="icone-menu"
              src="assets/icones-sideBar/exit.svg">
            <span *ngIf="open">
              <p class="nome-menu v-middle mb-0 ml-2 text-light">
                {{ 'COMPONENTS.SIDEBAR.go_premocenter' | transloco }}
              </p>
            </span>
          </a>
        </div>

        <div class="botao-abrir-fechar-menu">
          <a mat-list-item class="icon" (click)="acaoMenu(!open)">
            <span class="text-light">
              <img
                [src]="open
                  ? 'assets/icones-sideBar/close-menu.svg'
                  : 'assets/icones-sideBar/open-menu.svg'"
                [id]="open ? 'botaoFechar' : 'botao-abrir'"
                class="img-fluid">
            </span>
          </a>
        </div>
      </div>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-selecionar-idioma
  [exibirModal]="linguagemMenu"
  (modalEmitter)="fecharModal()">
</app-selecionar-idioma>
